import dayjs from 'dayjs';
import React from 'react';

interface OverheadUnderfootAmount {
  timestamp: string;
  moonUnderfootAt: string;
  moonOverheadAt: string;
}

const MINUTES_IN_HOUR = 60;

export const OverheadUnderfootAmount = (props: OverheadUnderfootAmount) => {
  const { moonUnderfootAt, moonOverheadAt, timestamp } = props;

  const overheadDiff = dayjs(timestamp).diff(moonOverheadAt, 'minute');
  const underfootDiff = dayjs(timestamp).diff(moonUnderfootAt, 'minute');
  const overheadNearest = Math.abs(overheadDiff) < Math.asin(underfootDiff);
  const nearestDateDiff = overheadNearest ? overheadDiff : underfootDiff;
  const nearestTimestamp = overheadNearest ? moonOverheadAt : moonUnderfootAt;
  const showValue = Math.abs(nearestDateDiff) <= 3 * MINUTES_IN_HOUR;
  const hourDiff = Math.abs(dayjs(timestamp).diff(nearestTimestamp, 'hour'));
  const minuteDiff = Math.abs(dayjs(timestamp).diff(nearestTimestamp, 'minute') % 60);

  if (!showValue) {
    return null;
  }

  return (
    <>
      {overheadNearest ? 'Overhead' : 'Underfoot'}
      <strong>
        {nearestDateDiff >= 0 ? '+' : '-'}
        {hourDiff > 0 && `${hourDiff}h`} {minuteDiff > 0 && `${minuteDiff}m`}
      </strong>
    </>
  );
};
